@if (ssBasket(); as basket) {
  <section class="employee-basket-card employee-ss-basket-info">
    <header class="employee-basket-card__header">
      <mat-icon class="employee-basket-card__dot" [style.color]="wls.warnColor">lens</mat-icon>
      <h2 class="employee-basket-card__title" [style.color]="wls.accentColor">
        {{ 'financing-plans.salary-sacrifice' | translate }}
      </h2>
    </header>

    <div class="employee-basket-card__available-label">
      {{ 'employee.basket.available-gross-salary' | translate | uppercase }}
    </div>
    <div class="employee-basket-card__available-amounts">
      <span class="employee-basket-card__available-amount">
        {{
          basket.AvailableConvertibleAmount / PER_MONTH_COEFF | flexyooNumber: 'currency' : false
        }}
      </span>

      <span class="employee-basket-card__available-label"
        >/ {{ 'employee.basket.per-month' | translate }}</span
      >
    </div>
    <div class="employee-basket-card__available-amounts fo-mb-15">
      <span class="employee-basket-card__available-amount">
        {{ basket.AvailableConvertibleAmount | flexyooNumber: 'currency' : false }}
      </span>
      <span class="employee-basket-card__available-label"
        >/ {{ 'employee.basket.per-year' | translate }}</span
      >
    </div>

    <flexyoo-employee-basket-progress-bar
      [color]="wls.warnColor"
      [total]="basket.ConvertibleGrossSalary"
      [used]="basket.SpentSSGrossAmount"
    />

    <div class="employee-ss-basket-info__details">
      <div class="employee-ss-basket-info__detail-column">
        <span>
          {{ 'employee.basket.spent' | translate | uppercase }}
        </span>
        <span>
          {{ basket.SpentSSGrossAmountPerMonth | flexyooNumber: 'currency' : false }}
          / {{ 'employee.basket.per-month' | translate }}
        </span>
        <span>
          {{ basket.SpentSSGrossAmount | flexyooNumber: 'currency' : false }}
          / {{ 'employee.basket.per-year' | translate }}
        </span>
      </div>
      <div class="employee-ss-basket-info__detail-column">
        <span>
          {{ 'employee.basket.gross-salary' | translate | uppercase }}
        </span>
        <span>
          {{ basket.ConvertibleGrossSalary / PER_MONTH_COEFF | flexyooNumber: 'currency' : false }}
          / {{ 'employee.basket.per-month' | translate }}
        </span>
        <span>
          {{ basket.ConvertibleGrossSalary | flexyooNumber: 'currency' : false }}
          / {{ 'employee.basket.per-year' | translate }}
        </span>
      </div>
    </div>
  </section>
}
